import {RouterModule} from "@angular/router";
import {NgModule} from "@angular/core";
import {DASHBOARD_ROUTE} from "./modules/dashboard/dashboard.route";
import {LoginComponent} from "./components/login/login.component";
import {STATISTIC_ROUTE} from "./modules/statistic/statistic.component";

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          pathMatch: 'full',
          redirectTo: 'dashboard',
        },
        {path: 'login', component: LoginComponent},
        ...DASHBOARD_ROUTE,
        ...STATISTIC_ROUTE,
      ],
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
